import type { FC, ReactNode } from 'react';
import { useFullwidth } from 'src/hooks/use-fullwidth';
import { cn } from 'src/utils/cn';

export type ContainerProps = { ignoreFullwidth?: boolean; children: ReactNode };

export const Container: FC<ContainerProps> = ({
  ignoreFullwidth,
  children,
}) => {
  const [fullwidth] = useFullwidth();
  const computedFullWidth = ignoreFullwidth ? false : fullwidth;
  return (
    <div
      className={cn(
        `
          mx-auto transition-[width] duration-300 ease-out
          print:w-full print:px-2xl
        `,
        computedFullWidth &&
          `
            w-full
            not-legacy:px-2xl
            legacy:px-[2.5rem]
          `,
        !computedFullWidth &&
          `
            w-auto
            not-legacy:px-xl
            md:w-[75rem]
            lg:w-[97rem]
            xl:w-[117rem]
            legacy:px-[1.5rem]
          `
      )}
    >
      {children}
    </div>
  );
};
